import * as React from 'react';

import { Spinner } from '@fluentui/react';
import { AsyncData } from '../../redux/core';
import { connect } from 'react-redux';
import { RootState } from '../../redux/types';
import { PatientFileData } from '../../redux/patient-files/types';
import { fetchPatientFiles } from '../../redux/patient-files/actions';
import { PatientFileDialog } from '../visit/dialogs/PatientFileDialog';
import { bindActionCreators, Dispatch } from 'redux';

interface OwnProps {
  patientId: string;
}

interface StateProps {
  files?: AsyncData<PatientFileData[]>;
}

interface DispatchProps {
  actions: {
    fetchPatientFiles: (patientId: string) => void;
  };
}

type InsuranceCardProps = OwnProps & StateProps & DispatchProps;

class Component extends React.Component<InsuranceCardProps> {
  public componentDidMount() {
    this.props.actions.fetchPatientFiles(this.props.patientId);
  }

  public render(): JSX.Element {
    const { files } = this.props;
    let insuranceCardFiles = files?.data?.filter((d) => d.document_type === 'insuranceCard') || [];
    insuranceCardFiles = insuranceCardFiles.slice(0, insuranceCardFiles.length > 2 ? 2 : insuranceCardFiles.length);

    if (files?.isFetching) {
      return <Spinner style={{ alignItems: 'flex-start', marginTop: 10 }} />;
    }

    if (insuranceCardFiles.length === 0) {
      return <span>No insurance card images found.</span>;
    }

    return (
      <div style={{ display: 'block', marginTop: 5, marginBottom: 5 }}>
        {insuranceCardFiles &&
          insuranceCardFiles.map((file) => {
            return (
              <img
                alt=""
                onClick={() => this.onInsuranceCardClick(file._id, insuranceCardFiles)}
                key={file._id}
                src={file.thumbnail_url}
                style={{ width: 200, marginRight: 10, cursor: 'pointer' }}
              />
            );
          })}
      </div>
    );
  }

  public onInsuranceCardClick = (activeFileId: string, files: PatientFileData[]) => {
    const { patientId } = this.props;
    PatientFileDialog.show({ files, activeFileId, patientId, hideDocumentType: true });
  };
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  return {
    files: state.patientFiles.data[ownProps.patientId],
  };
};

export function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    actions: bindActionCreators({ fetchPatientFiles }, dispatch),
  };
}

export const InsuranceCard = connect(mapStateToProps, mapDispatchToProps)(Component);
